<vc-notification></vc-notification>
<a href="javascript:void(0);" (click)="skipToMainContent()" class="sr-only sr-only-focusable">Skip to main content</a>
@if (!loading) {
    <div class="vc-main-layout">
        <div class="vc-header-container">
            <vc-header
                [orgModels]="(orgModels$ | async) ?? []"
                [user]="user"
                [notifications]="(notifications$ | async) ?? []"
                [isOrgAdmin]="isOrgAdmin"
                [isImpersonating]="userFullName"
                [theme]="theme"
                (changeOrg)="selectOrg($event)"
                (changeLang)="changeLang($event)"
                (endImpersonation)="endImpersonation()"
                (changeTheme)="changeTheme($event)"
                (logout)="logout()"></vc-header>
        </div>
        <div class="vc-content-wrapper">
            @if (!forcePasswordChangeDialog && !pauseForLogout) {
                <vc-side-navigation
                    [items]="navigationTree"
                    [expandLabel]="'CORE.EXPAND' | transloco"
                    [collapseLabel]="'CORE.COLLAPSE' | transloco"
                    (itemClick)="mainContentFocus()"></vc-side-navigation>
                <div #mainContent class="vc-main-wrapper" id="vc-main" tabindex="-1">
                    @if (user) {
                        <main class="vc-main-content" cdkScrollable tabindex="-1">
                            <router-outlet></router-outlet>
                        </main>
                    }
                </div>
            }
        </div>
    </div>
}

@if (user) {
    <vc-change-password-dialog
        [username]="user.getUsername()"
        [(visible)]="forcePasswordChangeDialog"
        [forceReset]="true"
        (passwordChange)="updateForcePasswordChange($event)"></vc-change-password-dialog>

    <vc-dialog
        [visible]="sessionTimeout.warningVisible()"
        [title]="'CORE.SESSION.EXPIRING.TITLE' | transloco"
        [primaryLabel]="'CORE.SESSION.EXPIRING.STAY_SIGNED_IN' | transloco"
        [secondaryLabel]="'CORE.USER.LOGOUT' | transloco"
        width="430px"
        [closeOnPrimary]="false"
        [closeOnSecondary]="false"
        [closeOnClickOutside]="false"
        [showCloseIcon]="false"
        [loading]="sessionTimeout.refreshLoading()"
        [primaryDisabled]="sessionTimeout.refreshLoading()"
        [secondaryDisabled]="sessionTimeout.refreshLoading()"
        [actionsOnLeft]="true"
        (primaryTrigger)="staySignedIn()"
        (secondaryTrigger)="onSessionLogout()">
        <p>
            {{ 'CORE.SESSION.EXPIRING.DESCRIPTION' | transloco: { countdown: sessionTimeout.countdown() } }}
        </p>
    </vc-dialog>
}
